import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from '../../../_services/contact.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { CompanyService } from '../../../_services/company.service';

@Component({
  selector: 'app-edit-contact',
  templateUrl: './edit-contact.component.html',
  styleUrls: ['./edit-contact.component.css']
})
export class EditContactComponent implements OnInit {
  // @Input() companies;
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_contact = false;
  private contact_id: number;

  constructor(private service: ContactService, private company_service: CompanyService) { }

  edit_contact = new FormGroup({
    email: new FormControl(''),
    company: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('')
  });

  ngOnInit() {
  }

  openModal(contact) {
    this.contact_id = contact.id; // Set the Contact_id needed in the Update Contact URL
    this.edit_contact.patchValue(contact);

    if (!contact.company) { // May Never Happen..
      jQuery('#edit-contact-modal').find('.dropdown').dropdown('set value', '');
      jQuery('#edit-contact-modal').find('.dropdown').dropdown('set text', 'Aucune');
    }
    jQuery('#edit-contact-modal').modal({ inverted: true }).modal('show'); // Show the Modal
  }

  // Update Contact
  submitContactForm() {
    this.edit_contact.disable();   // Disable the form to avoid changes during the Updating process
    this.updating_contact = true; // Trigger the Loading button apparition
    jQuery('#edit-contact-modal').modal({ closable: false }); // Set the modal unclosable during the Updating process    
    this.service.updateContact(this.contact_id, this.edit_contact.value) // Update the Contact
      .subscribe(response => {
        jQuery('#edit-contact-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
        this.updating_contact = false; // Disable the loading button apparition
        this.edit_contact.enable(); // Re Enable the Form
        this.edit_contact.reset(); // Reset It
        this.contact_id = undefined;
        this.refresh.emit(true); // Emmit the refresh Event
      });

  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/contact/edit-contact/edit-contact.component.ts